import { Box } from "@mui/material";
import Verdict from "./Verdict";
import GaugeRow from "./GaugeRow";
import SimResult from "./SimResult";
import PropulsionCharts from "./PropulsionCharts";

/**
 * Shared eCalc-style results block used by both the public and authed calculator
 * pages: gauge dials → detail panels → motor-characteristic charts.
 *
 * @param {object} result  a /simulate result (backend or client model)
 * @param {Array}  curve   modeled throttle sweep for the charts (optional)
 * @param {node}   action  optional element rendered between gauges and panels
 * @param {string} chartNote caption shown on the charts block
 * @param {boolean} premiumLocked passed through to SimResult
 */
const ResultsView = ({ result, curve, action, chartNote, premiumLocked = false }) => {
  if (!result) return null;
  return (
    <Box>
      <Verdict result={result} />
      <GaugeRow result={result} />
      {action}
      <SimResult result={result} premiumLocked={premiumLocked} showHero={false} />
      <PropulsionCharts curve={curve} note={chartNote} />
    </Box>
  );
};

export default ResultsView;
